module.exports = __webpack_public_path__ + "dddad709.woff";